import { Dropdown, TextArea, Form } from 'semantic-ui-react';

import { useCallback, useState } from 'react';

import { gql, useMutation } from '@apollo/client';

import {
    ABSENT_WITH_REASON,
    STATUS_OPTIONS as statusOptions
} from '../constants';

import throttle from 'lodash.throttle';

import './SessionUpdater.css'

// Define mutation
const UPDATE_ATTENDANCE_MUATION = gql`
    mutation UpdateAttendance($attendeeUserId: Int, $sessionId: Int, $status: String!, $details: String) {
        updateAttendance(attendeeUserId: $attendeeUserId, sessionId: $sessionId, status: $status, details: $details) {
            status
            details
        }
    }`;



interface Options {
    sessionId: number,
    userId: number,
    initStatus: string,
    initDetails: string,
    refetch: () => void,
}

const StatusUpdater = ({
    sessionId,
    userId,
    initStatus,
    initDetails,
    refetch,
}: Options) => {
    const [status, setStatus] = useState(initStatus);
    const [showDetails, setShowDetials] = useState(initStatus === ABSENT_WITH_REASON);
    const [details, setDetails] = useState(initDetails);

    //const [updateAttendance, { data, loading, error }] = useMutation(UPDATE_ATTENDANCE_MUATION);
    const [updateAttendance] = useMutation(UPDATE_ATTENDANCE_MUATION);

    // eslint-disable-next-line
    const update = useCallback(throttle(async (st: string, de: string) => {
        await updateAttendance({
            variables: {
                attendeeUserId: userId,
                sessionId,
                status: st,
                details: de,
            }
        });
        refetch();
    }, 200, { leading: false, trailing: true }), [updateAttendance, userId, sessionId])


    const handleStatusChange = useCallback(async (value: string) => {
        setStatus(value);

        if (value === ABSENT_WITH_REASON) {
            setShowDetials(true)
        } else {
            setDetails("")
            setShowDetials(false)
        }

        await update(value, "")
    },[setShowDetials, setDetails, update]);

    const handleDetailsChange = useCallback(async (newDetails: string) => {
        setDetails(newDetails);
        await update(status, newDetails)
    }, [setDetails, update, status])

    const notPresentOrAbsent = (status: string) => status !== 'PRESENT' && status !== 'ABSENT' && status !== "PENDING";
    return (
        <>
            <div className="main-container">
                <input
                    name="status"
                    type="radio"
                    value="left"
                />
                <label
                    onClick={() => {
                        handleStatusChange('PRESENT')
                    }}
        className={status === 'PRESENT' ? "sessionUpdaterLabel highlight-green text": (!notPresentOrAbsent(status) ? "sessionUpdaterLabel text" : "sessionUpdaterLabel highlight-yellow text")}
                    htmlFor="left"
                >
                    <h4>Present</h4>
                </label>
                <input
                    name="status"
                    type="radio"
                    value="center"
                />
                <label
                    onClick={() => {
                        handleStatusChange('ABSENT')
                    }}
                    className={status === 'ABSENT' ? "sessionUpdaterLabel highlight-red text": (!notPresentOrAbsent(status) ? "sessionUpdaterLabel text" : "sessionUpdaterLabel highlight-yellow text")}
                    htmlFor="center"
                >
                    <h4>Absent</h4>
                </label>
                <label className="sessionUpdaterLabel">
                    <Dropdown
                        placeholder='Reason...'
                        fluid
                        lazyLoad
                        selection
                        value={status === 'ABSENT' || status === 'PRESENT' ? '' : status}
                        onChange={(_, d) => handleStatusChange(String(d.value))}
                        options={statusOptions}
                    />
                </label>
            </div>
            {showDetails &&
                <Form>
                    <TextArea
                style={{ marginTop: '0.5em' }}
                        onChange={(_,d) => handleDetailsChange(String(d.value))}
                        value={details}
                        placeholder='Reason details...'
                    />
                </Form>
            }
        </>
    )
}

export { StatusUpdater }
